import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    '& > button[disabled]': {
      color: 'rgb(22,159,218, 0.5)',
      cursor: 'default'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'grid'
    }
  },

  button: {
    width: 'auto',
    borderRadius: '100rem',
    margin: '4px 8px 0 1.125rem',
    height: '1.75rem',
    padding: '0.5rem 1rem',
    [theme.breakpoints.down('sm')]: {
      margin: '0'
    }
  },

  htmlButton: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto',
    border: 'none',
    fontSize: theme.size.base,
    color: 'rgb(22,159,218)',
    background: 'transparent',
    cursor: 'pointer'
  },

  icon: {
    marginLeft: '0.25rem'
  },

  selfBaseline: {
    alignSelf: 'baseline'
  },

  input: {
    flex: '1',
    border: '2px solid #EFEFEF',
    borderRadius: '5px',
    boxSizing: 'border-box',
    padding: '0.125rem',
    backgroundColor: 'rgb(246, 248, 249)',
    fontSize: theme.size.sm,
    wordBreak: 'normal',
    overflowWrap: 'anywhere',

    '&:focus-within': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, 0.25)',

      '& .MuiInputBase-input': {
        outline: '0'
      }
    },

    '& .text': {
      minHeight: '1rem',
      maxHeight: '5rem'
    },

    '& .text > div': {
      height: 'auto !important',
      maxHeight: '5rem',
      minHeight: '1rem'
    },

    '& .text > div > div': {
      height: 'auto !important',
      maxHeight: '5rem'
    }
  },

  buttonHolder: {
    alignSelf: 'baseline',
    display: 'flex',
    marginTop: 3,
    marginRight: '-6px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '0.5rem',
      justifyContent: 'end'
    }
  }
}))

export default useStyles
